import { parseUtcTimestamp, stateRaces, stateShowSidebarMobile } from '@infinitro/global';
import { derived, writable } from 'svelte/store';
export { jackpotAmounts, jackpotMEGA, startMegajackpotPolling } from './jackpot-mega.svelte';
export const menuAutoCollapse = writable(false);
export const menuAutoCollapsed = writable(false);
export const languageIsExpanded = writable(false);
export const menuMobileOpen = writable(false);
// Sincronizar el estado de menuMobileOpen con stateShowSidebarMobile
stateShowSidebarMobile.subscribe((value) => {
    menuMobileOpen.set(value);
});
// Lazily started: the interval only runs while something is actually subscribed
// (i.e. the Halloween weekly-races banner is mounted), not on every brand's page load.
const raceClockTick = writable(Date.now(), (set) => {
    const id = setInterval(() => set(Date.now()), 1000);
    return () => clearInterval(id);
});
/** The currently running race (startDate <= now <= endDate), or null. Ticks every second. */
export const stateActiveRace = derived([stateRaces, raceClockTick], ([$races, $now]) => $races?.find((race) => {
    const start = parseUtcTimestamp(race.startDate);
    const end = parseUtcTimestamp(race.endDate);
    return $now >= start && $now <= end;
}) ?? null);
/** Live DD:HH:MM:SS breakdown of time left on the active race, or null once it's over. */
export const stateActiveRaceCountdown = derived([stateActiveRace, raceClockTick], ([$race, $now]) => {
    if (!$race)
        return null;
    const diffMs = parseUtcTimestamp($race.endDate) - $now;
    if (diffMs <= 0)
        return null;
    const totalSeconds = Math.floor(diffMs / 1000);
    return {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60
    };
});
